'use client';
import { ImageProps } from 'next/image';
import { IGeneralSettings } from '../../../models/IGeneralSettings';
import ThemedImage from '../ThemedImage';
import { twMerge } from 'tailwind-merge';
import { useEffect, useState } from 'react';

export default function Logo({ locale = 'ar', settings, wrapperClassName, ...props }: { locale?: string; wrapperClassName?: string; } & Partial<ImageProps> & { settings: IGeneralSettings }) {
  const {logo, logoDarkmode} = settings.publisherSettings;

    const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div className={twMerge('w-fit h-fit grid place-items-center flex-shrink-0', wrapperClassName)}>
    <a href={'/'} title={'logo'} className={twMerge('cursor-pointer w-[161px] h-[48px] desktop:w-[194px] desktop:h-[58px] flex-shrink-0', props.className)}>
     {[logo,logoDarkmode].every(x => !x) ? null : <ThemedImage src={settings.publisherSettings.logo} darkSrc={settings.publisherSettings.logoDarkmode} alt='logo' eager className={twMerge('h-full w-full')} />}
    </a>
    </div>
  )
}